import React from 'react';
import { Button, Card, Container } from 'react-bootstrap';
import { useLazyQuery, gql, useQuery, useMutation } from '@apollo/client';
import { toastWarning, toastSuccess, toastFailure } from 'utils/toasts';

const gqlFetchQr = gql`
  query getContainerQrcodes($limit: Int, $offset: Int, $order: String, $where: String) {
    getContainerQrcodes(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        qrCode
        binSerialNo
        collectionPointId
        collectionpoint {
          id
          name
          addressLine1
          addressLine2
          addressArea
          addressCity
          postalCode
          profession {
            id
            name
          }
        }
        containertype {
          id
          name
        }
        declaredByUser
        declaredDate
        firstDate
        firstUser
        lastDate
        lastUser
      }
    }
  }
`;
const gqlAddCollectionOrderFromContainer = gql`
  mutation addCollectionOrderFromContainer($qrCode: String) {
    addCollectionOrderFromContainer(qrCode: $qrCode) {
      id
      code
    }
  }
`;

export const QrPage = ({ id }: { id: string }) => {
  const { loading, data, error } = useQuery(gqlFetchQr, {
    variables: {
      offset: 0,
      limit: 10,
      order: 'declaredDate DESC',

      where: `{\"qrCode\":\"https://myfotokiklosi.com/?id=${id}\"}`,
    },
  });

  // ********************************************************************************
  // ΝΕΑ ΑΙΤΗΣΗ ΣΥΛΛΟΓΗΣ
  // ********************************************************************************
  const [addCollectionOrderFromContainer] = useMutation(gqlAddCollectionOrderFromContainer);
  const placeOrder = async () => {
    const res: any = await addCollectionOrderFromContainer({
      variables: { qrCode: `https://myfotokiklosi.com/?id=${id}` },
    }).catch((err) => {
      const msg = err.graphQLErrors.map((e) => e.message).join(', ');
      toastWarning(msg);
      return { errors: err.graphQLErrors };
    });
    if (!res.errors) {
      console.log('Collection order placed successfully:', res.data);
      toastSuccess('Η αίτηση συλλογής υποβλήθηκε με επιτυχία!');
    }
  };

  return (
    <div id="qr-page" className="d-flex align-items-center justify-content-center">
      <Card className="text-center" style={{ maxWidth: 520, width: '90%' }}>
        <Card.Body className="pb-5">
          <img
            src={process.env.PUBLIC_URL + '/logo.png'}
            alt="logo"
            style={{ maxWidth: 160, height: 'auto', marginBottom: 12 }}
          />
          <Card.Title style={{ fontSize: '1.6rem', fontWeight: 600, color: '#006EB6' }}>
            Φωτοκύκλωση α.ε.
          </Card.Title>
          <Card.Subtitle className="mb-2 text-muted">
            <strong>ID: {id}</strong>
          </Card.Subtitle>

          <Card.Text style={{ marginTop: 12 }}>Καλώς ήρθατε στην σελίδα συνεργάτη.</Card.Text>

          <QrInfo loading={loading} data={data} error={error} />

          <div style={{ paddingTop: '1.5rem', margin: '0 auto' }}>
            <p>
              Αν ο κάδος έχει σχεδόν γεμίσει ειδοποιήστε μας πατώντας το παρακάτω κουμπί και θα
              έρθουμε το συντομότερο να τον αδειάσουμε!
            </p>

            <Button
              onClick={() => {
                console.log('pressed');
                placeOrder();
              }}
              variant="primary"
              size="lg"
              block
            >
              Ειδοποίηση Γεμάτου Κάδου
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

const QrInfo = ({ loading, data, error }: { loading: boolean; data: any; error: any }) => {
  if (loading) return <p>Φόρτωση δεδομένων...</p>;
  if (error) return <p>Σφάλμα κατά την φόρτωση δεδομένων: {error.message}</p>;
  if (!data || data.getContainerQrcodes.data.length === 0)
    return <p>Δεν βρέθηκαν δεδομένα για το συγκεκριμένο QR code.</p>;

  const qrData = data.getContainerQrcodes.data[0];

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
      <div
        style={{
          width: '100%',
          maxWidth: 460,
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
          border: '1px solid rgba(0,0,0,0.06)',
          padding: 16,
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <div style={{ color: '#006EB6', fontWeight: 700, fontSize: '1.05rem', marginBottom: 6 }}>
            Πληροφορίες Κάδου
          </div>
          <div style={{ fontSize: '1.05rem', fontWeight: 600 }}>{qrData.containertype.name}</div>
        </div>

        <div
          style={{
            background: 'linear-gradient(180deg, rgba(0,110,182,0.03), rgba(0,110,182,0.01))',
            borderRadius: 10,
            padding: 12,
            border: '1px solid rgba(0,0,0,0.04)',
            marginBottom: 12,
          }}
        >
          <div style={{ fontSize: '0.95rem', color: '#444', marginBottom: 6 }}>
            <strong className="text-primary">Σημείο Συλλογής:</strong>
          </div>
          <div style={{ fontWeight: 700, color: '#222', marginBottom: 6 }}>
            {qrData.collectionpoint.name}
          </div>
          <div style={{ fontSize: '0.85rem', color: '#666' }}>
            <em>{qrData.collectionpoint.profession.name}</em>
          </div>
          {/* <div style={{ fontSize: '0.85rem', color: '#666' }}>
            <em>
              <strong className="text-muted">QR:</strong> {qrData.qrCode}
            </em>
          </div> */}
        </div>

        <div style={{ padding: '8px 4px' }}>
          <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: 6 }}>
            <strong className="text-primary">Διεύθυνση:</strong>
          </div>
          <div style={{ fontWeight: 600, color: '#222', lineHeight: 1.4 }}>
            <div>{qrData.collectionpoint.addressLine1}</div>
            {qrData.collectionpoint.addressLine2 && (
              <div>{qrData.collectionpoint.addressLine2}</div>
            )}
            <div>{qrData.collectionpoint.addressArea}</div>
            <div>
              {qrData.collectionpoint.addressCity}, {qrData.collectionpoint.postalCode}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
